import { motion } from 'framer-motion'
import { Star, MapPin, Calendar } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Destination } from '../data/destinations'

interface DestinationCardProps {
  destination: Destination
}

const DestinationCard = ({ destination }: DestinationCardProps) => {
  const navigate = useNavigate()

  return (
    <motion.div
      whileHover={{ y: -5 }}
      className="card overflow-hidden group"
    >
      {/* Image */}
      <div className="relative overflow-hidden">
        <img
          src={destination.image}
          alt={destination.name}
          className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-300"
        />
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1 flex items-center space-x-1">
          <Star className="h-4 w-4 text-yellow-500 fill-current" />
          <span className="text-sm font-semibold text-gray-900">
            {destination.rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
          <div className="flex items-center space-x-2 text-white text-sm">
            <MapPin className="h-4 w-4" />
            <span>{destination.location}</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          {destination.name}
        </h3>
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {destination.description}
        </p>

        {/* Details */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-2 text-gray-500 text-sm">
            <Calendar className="h-4 w-4" />
            <span>{destination.duration}</span>
          </div>
          <div className="text-2xl font-bold text-primary-600">
            {destination.price}
          </div>
        </div>

        {/* Action Button */}
        <button 
          onClick={() => navigate(`/trip/${destination.id}`)}
          className="w-full btn-primary cursor-pointer"
        >
          View Details
        </button>
      </div>
    </motion.div>
  )
}

export default DestinationCard
